namespace TabAurous.ColumnFormatter {
    function getEffectiveValue(item, field: any, editor:any): any {
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];
        if (pending && pending[field] !== undefined) {
            return pending[field];
        }
        return item[field];
    }

    // **** For Decimal Editor in Grid ****
    export function WeightFormatter(ctx, editor:any) {
        var klass = 'edit numeric';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0.000') + "' />";
    }

    export function numericInputFormatter(ctx, editor:any) {
        var klass = 'edit numeric';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0.00') + "' />";
    }

    export function ReadonlynumericInputFormatter(ctx, editor: any) {
        var klass = 'edit numeric readonly';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0.00') + "' />";
    }

    // **** For Decimal Editor in Grid ****
    export function AmountFormatter(ctx, editor: any) {
        var klass = 'edit numeric';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0.00') + "' />"; //TODO: Set Dynamic Currency and culture
    }


    // **** For Decimal Editor in Grid ****
    export function ReadOnlyWeightFormatter(ctx, editor: any) {
        var klass = 'edit numeric readonly';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0.000') + "' />";
    }

    export function ReadOnlyAmountFormatter(ctx, editor: any) {
        var klass = 'edit numeric readonly';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0.00') + "' />"; //TODO: Set Dynamic Currency and culture
    }

    // **** For Integer Editor in Grid ****
    export function integerInputFormatter(ctx, editor: any) {
        var klass = 'edit numeric integer';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0') + "' />";
    }

    export function ReadOnlyIntegerInput(ctx, editor: any) {
        var klass = 'edit numeric integer readonly';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];

        if (pending && pending[ctx.column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, ctx.column.field, editor) as number;
        var width = (ctx.column.width) as number - 10;
        return value === undefined
            ? "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='' />"
            : "<input tabindex='0' type='text' style='text-align: right; width:" + width + "px;' class='" + klass +
            "' data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0') + "' />";
    }

    // **** For String Editor in Grid ****
    export function stringInputFormatter(ctx, editor: any) {
        var klass = 'edit string';
        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];
        var column = ctx.column as Slick.Column;

        if (pending && pending[column.field] !== undefined) {
            klass += ' dirty';
        }
        var value = getEffectiveValue(item, column.field, editor) as string;
        return "<input tabindex='0' type='text' required class='" + klass +
            "' data-field='" + column.field +
            "' value='" + Q.attrEncode(value) +
            "' maxlength='" + column.sourceItem.maxLength + "' />";
    }

    // **** for Dropdown in Gird ****
    export function selectFormatter(ctx: Slick.FormatterContext, idField: string, lookup: Q.Lookup<any>, editor: any) {
        var klass = 'edit';
        var item = ctx.item
        var id = editor.id(item);
        var pending = editor.pendingChanges[id]
        var column = ctx.column as Slick.Column;

        if (pending && pending[idField] !== undefined) {
            klass += ' dirty';
        }

        var value = getEffectiveValue(item, idField, editor);
        var markup = "<select tabindex='0' class='" + klass +
            "' data-field='" + idField +
            "' style='width: 100%; max-width: 100%'>";
        for (var c of lookup.items) {
            let id = c[lookup.idField];
            markup += "<option value='" + Q.attrEncode(id) + "'"
            if (id == value) {
                markup += " selected";
            }
            markup += ">" + Q.htmlEncode(c[lookup.textField]) + "</option>";
        }
        return markup + "</select>";
    }
     // **** For Integer Editor in Grid ****
    export function integerReadOnlyFormatter(ctx: Slick.FormatterContext, editor: any) {

        var item = ctx.item;
        var id = editor.id(item);
        var pending = editor.pendingChanges[id];
        var width = (ctx.column.width) as number - 10;
        //if (pending && pending[ctx.column.field] !== undefined) {
        //    klass += ' dirty';
        //}
        var value = editor.getEffectiveValue(item, ctx.column.field) as number;
        return value === undefined
            ? "<input type='submit' style='text-align: right; width:" + width + "px; data-field='" + ctx.column.field +
            "' value=''/>"
            : "<input type='submit' style='text-align: right; width:" + width + "px;data-field='" + ctx.column.field +
            "' value='" + Q.formatNumber(value, '0') + "' />";
    }

}